// extracted by mini-css-extract-plugin
module.exports = {"progressBarSvg":"SrCircularProgressBar--progressBarSvg--3bMIC","highlightYellowFadeIn":"SrCircularProgressBar--highlightYellowFadeIn--24M6k"};